import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AppInfoService } from 'core/app-info/app-info.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-leads-reject',
  templateUrl: './leads-reject.component.html',
  styleUrls: ['./leads-reject.component.scss'],
  standalone: false
})
export class LeadsRejectComponent implements OnInit {
  selectForm;
  leadId: string;
  appStrings: AppLocalization;
  onRejectLead = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<LeadsRejectComponent>,
    private formBuilder: UntypedFormBuilder,
    private appInfoService: AppInfoService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.leadId = data.leadId;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.selectForm = this.formBuilder.group({
      reason: ['', Validators.required]
    });
  }

  close(result?): void {
    this.dialogRef.close(result);
  }

  rejectLead() {
    if (this.selectForm.valid) {
      this.onRejectLead.emit(this.selectForm.controls.reason.value);
      this.close();
    }
  }

}
